import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-main" }
const _hoisted_2 = { class: "infra-overview-section" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = { class: "section-subtitle" }
const _hoisted_6 = { class: "layers-horizontal-container" }
const _hoisted_7 = { class: "project-cta-section" }
const _hoisted_8 = { class: "cta-content" }
const _hoisted_9 = { class: "cta-badge" }
const _hoisted_10 = { class: "cta-title" }
const _hoisted_11 = { class: "cta-description" }
const _hoisted_12 = { class: "cta-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_hero_section = _resolveComponent("hero-section")!
  const _component_InfraLayerCard = _resolveComponent("InfraLayerCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_hero_section),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "infra-section-anchor" }, null, -1)),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('infra.title')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('infra.intro')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_InfraLayerCard, {
            layerNumber: _ctx.$t('infra.layers.l0.name'),
            title: _ctx.$t('infra.layers.l0.title'),
            description: _ctx.$t('infra.layers.l0.shortDesc'),
            badge: "OSI 1-2",
            icon: "mdi-server-network",
            variant: "ln-glass-teal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToInfraLayer('l0')))
          }, null, 8, ["layerNumber", "title", "description"]),
          _createVNode(_component_InfraLayerCard, {
            layerNumber: _ctx.$t('infra.layers.l1.name'),
            title: _ctx.$t('infra.layers.l1.title'),
            description: _ctx.$t('infra.layers.l1.shortDesc'),
            badge: "OSI 3-4",
            icon: "mdi-kubernetes",
            variant: "ln-glass-terracotta",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToInfraLayer('l1')))
          }, null, 8, ["layerNumber", "title", "description"]),
          _createVNode(_component_InfraLayerCard, {
            layerNumber: _ctx.$t('infra.layers.l2.name'),
            title: _ctx.$t('infra.layers.l2.title'),
            description: _ctx.$t('infra.layers.l2.shortDesc'),
            badge: "OSI 5-6",
            icon: "mdi-database",
            variant: "ln-glass-stone",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToInfraLayer('l2')))
          }, null, 8, ["layerNumber", "title", "description"]),
          _createVNode(_component_InfraLayerCard, {
            layerNumber: _ctx.$t('infra.layers.l3.name'),
            title: _ctx.$t('infra.layers.l3.title'),
            description: _ctx.$t('infra.layers.l3.shortDesc'),
            badge: "OSI 7",
            icon: "mdi-shield-lock",
            variant: "ln-glass-elevated",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToInfraLayer('l3')))
          }, null, 8, ["layerNumber", "title", "description"])
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", {
          class: "cta-card ln-glass-elevated",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.navigateToProjects && _ctx.navigateToProjects(...args)))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "cta-visual-bg" }, [
            _createElementVNode("span", { class: "mdi mdi-rocket-launch-outline" })
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('nav.projects')), 1),
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('home.cta.title')), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('home.cta.description')), 1),
            _createElementVNode("button", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.cta.button')), 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mdi mdi-arrow-right" }, null, -1))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}